<template>
  <div>
    <template v-if="isJSONData">
      <el-link
        @click="expandAll"
        type="primary"
        style="margin-right:20px;"
      >
        全部展开
      </el-link>
      <el-link
        @click="collapseAll"
        type="primary"
        style="margin-right:20px;"
      >
        全部收起
      </el-link>
      <el-link type="primary" icon="el-icon-document-copy" @click.stop="onCopyCommit">一键复制</el-link>
      <vue-json-pretty
        style="margin-top:20px;"
        :data="parsedJsonData"
        :deep="deep"
        show-icon
      />
    </template>
    <el-input
      v-else-if="renderInput"
      :value="parsedJsonData"
      :autosize="{ minRows: 2, maxRows: maxRows }"
      type="textarea"
    />
  </div>
</template>

<script>
import clip from '@/utils/clipboard'
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'

// 判断是否为json字符串
function isJSON (str) {
  try {
    JSON.parse(str)
    return true
  } catch (e) {
    return false
  }
}

export default {
  components: {
    VueJsonPretty
  },
  props: {
    jsonData: {
      type: [Object, String],
      required: true
    },
    initialDeep: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      deep: this.initialDeep,
      maxRows: 5,
      renderInput: true
    }
  },
  computed: {
    parsedJsonData () {
      return isJSON(this.jsonData)
        ? JSON.parse(this.jsonData)
        : this.jsonData
    },
    isJSONData () {
      return isJSON(this.jsonData)
    }
  },
  methods: {
    expandAll () {
      if (this.isJSONData) {
        this.deep = 100
      } else {
        this.maxRows = 999
        this.renderInput = false
        this.$nextTick(() => {
          this.renderInput = true
        })
      }
    },
    collapseAll () {
      if (this.isJSONData) {
        this.deep = -1
      } else {
        this.maxRows = 5
        this.renderInput = false
        this.$nextTick(() => {
          this.renderInput = true
        })
      }
    },

    // 一键复制
    onCopyCommit (event) {
      clip(this.jsonData, event)
    }
  }
}
</script>

<style>
.vjs-value-string {
  color: green;
}
</style>



// WEBPACK FOOTER //
// src/components/JsonViewer/index.vue